import Modal from "@common/Modal";
import { addCurrencyFormatting, formatDate } from "@src/config/helper";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { paymentDetail } from "./paymentInterface";
import { isMobile } from "react-device-detect";

export default function PaymentDetailModal(props: paymentDetail) {
    const { show, handleClose,leadDetail } = props;    

    const navigate = useNavigate();
    
    const handleCopy = (url:string) => {
        navigator.clipboard.writeText(url);
        toast.success("Payment link copied to clipboard");
    };

    const getMMV = () => {
        if (
            leadDetail?.make_name ||
            leadDetail?.parent_model_name ||
            leadDetail?.version_name
        ) {
            return `${leadDetail?.make_name ?? ''} ${leadDetail?.parent_model_name ?? ''} ${leadDetail?.version_name ?? ''}`.trim();
        }
        return '';
    };
    
    const handlePaymentButton = (lead: Record<string, any> | any) => {
        if (isMobile) {
            navigate(`/generate-payment-link-app/${lead.leadId}?type=regenerate`);
        } else {
            navigate(`/generate-payment-link/${lead.leadId}?type=regenerate`);
        }
    };
    

    return (
        <div className="model-outer upload-error-popup dashboard-filter-popup">
            <Modal show={show} handleClose={handleClose}>

                {
                    Object.keys(leadDetail?.transaction_detail ?? {}).length > 0 &&
                    
                    (
                        <>
                        {/* Header */}
                            <div className="modal-header">
                                <h2>Payment Details</h2>
                                {/* <button className="close-btn" onClick={handleClose}>✕</button> */}
                            </div>

                            {/* Body */}
                            <div className="modal-body">
                                <div className="row">

                                   
                                    <div className="col-md-12">
                                        <div className="payment-section">
                                            <div className="section-header d-flex align-center space-bw p-sm-b">
                                                <h3>Application Details</h3>
                                                
                                            </div>

                                          {/* Application Details */}
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <span>Application ID :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>{leadDetail?.lead_code}</span>
                                                </div>
                                            </div>


                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Customer Name :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>{leadDetail?.customer_name}</span>
                                                </div>
                                            </div>

                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Insurer :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>{leadDetail?.insurer_name}</span>
                                                </div>
                                            </div>

                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Insured Object :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>Vehicle</span>
                                                </div>
                                            </div>

                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Object Details :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>{getMMV()}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Transaction Details */}
                                    <div className="col-md-12">
                                        <div className="payment-section">
                                            <div className="section-header d-flex align-center space-bw p-sm-b">
                                                <h3>Transaction Details</h3>
            
                                            </div>

                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Payment Status :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span style={{color:leadDetail?.transaction_detail?.color_code}}>{leadDetail?.transaction_detail?.payment_status}</span>
                                                </div>
                                            </div>

                                            {
                                                leadDetail?.transaction_detail?.payment_status_slug === "paid" && (
                                                    <>

                                                    <div className="payment-row row">
                                                        <div className="col-md-6">
                                                            <span>Transaction Date :</span>
                                                        </div>
                                                        <div className="col-md-6">
                                                             <span>{formatDate(new Date(leadDetail?.transaction_detail?.transaction_date))}</span>
                                                        </div>
                                                    </div>

                                                    <div className="payment-row row">
                                                        <div className="col-md-6">
                                                            <span>Transaction ID :</span>
                                                        </div>
                                                        <div className="col-md-6 d-flex space-bw">
                                                            <span>{leadDetail?.transaction_detail?.transaction_id}</span>
                                                            <span className="txt-copy" onClick={() => handleCopy(leadDetail?.transaction_detail?.transaction_id)}><i className="ic-content_copy"></i></span>
                                                        </div>
                                                    </div>
                                                    </>
                                                )
                                            }
                                            {
                                                leadDetail?.transaction_detail?.payment_status_slug !== "paid" && (
                                                    
                                                    <div className="payment-row row">
                                                        <div className="col-md-6">
                                                            <span>WPC Expiry Date :</span>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <span>{formatDate(new Date(leadDetail?.transaction_detail?.wpc_expiry_date))}</span>
                                                        </div>
                                                    </div>
                                                )
                                            }


                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Payment Method :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>{leadDetail?.transaction_detail?.payment_method}</span>
                                                </div>
                                            </div>

                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Premium Amount :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>{addCurrencyFormatting(leadDetail?.transaction_detail?.total_premium_amount)}</span>
                                                </div>
                                            </div>

                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Discount Amount :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>{addCurrencyFormatting(leadDetail?.transaction_detail?.customer_discount)}</span>
                                                </div>
                                            </div>

                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Admin Fee :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>{addCurrencyFormatting(leadDetail?.transaction_detail?.admin_fee)}</span>
                                                </div>
                                            </div>


                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Transaction Fee :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>{addCurrencyFormatting(leadDetail?.transaction_detail?.application_fee)}</span>
                                                </div>
                                            </div>

                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Total Payment :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>{addCurrencyFormatting(leadDetail?.transaction_detail?.total_pay_amount)}</span>
                                                </div>
                                            </div>

                                            {
                                                leadDetail?.transaction_detail?.payment_status_slug !== "paid" && (
                    
                                                    <div className="payment-row row">
                                                        <div className="col-md-6">
                                                            <span>Payment Link :</span>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <div className="d-flex">
                                                            <span className="truncate" title={leadDetail?.transaction_detail?.generated_url}>
                                    
                                                                {leadDetail?.transaction_detail?.generated_url}

                                                            </span>
                                                            <span className ="txt-copy space-bw" onClick={()=>handleCopy(leadDetail?.transaction_detail?.generated_url)}>
                                                                <i className="ic-content_copy"></i>
                                                            </span>

                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }

                                        </div>
                                    </div>

                                </div>
                            </div>

                            {
                                leadDetail?.transaction_detail?.payment_status_slug !== "paid" && (
                        
                                    <div className="payment-modal-footer p-lg-t">
                                        <button className="btn-line w-100" onClick={()=>handlePaymentButton(leadDetail)}>
                                        Regenerate Payment Link
                                        </button>
                                        
                                    </div>
                                )
                            }
                        </>
                    )
                }
                {
                    leadDetail?.show && (
                        <>
                            {/* Header */}
                            <div className="modal-header">
                                <h2>Payment Details</h2>
                                {/* <button className="close-btn" onClick={handleClose}>✕</button> */}
                            </div>

                            {/* Body */}
                            <div className="modal-body">
                                <div className="row">

                                    {/* Transfer to Bank */}
                                    <div className="col-md-12">
                                        <div className="payment-section">
                                            <div className="section-header d-flex align-center space-bw p-sm-b">
                                                <h3>Transfer to Bank</h3>
                                                <i className="ic-content_copy"></i>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <span>Bank Name :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>BCA</span>
                                                </div>
                                            </div>


                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Account No :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>0842475137</span>
                                                </div>
                                            </div>

                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Ac. Holder Name :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>PT Carbay Service Pvt. Ltd.</span>
                                                </div>
                                            </div>

                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Processing Fee :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>5,000</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Transfer to Virtual Account */}
                                    <div className="col-md-12">
                                        <div className="payment-section">
                                            <div className="section-header d-flex align-center space-bw p-sm-b">
                                                <h3>Transfer to Virtual Account</h3>
                                                <i className="ic-content_copy"></i>
                                            </div>

                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Bank Name :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>BCA</span>
                                                </div>
                                            </div>

                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Account No :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>0842475137</span>
                                                </div>
                                            </div>

                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Ac. Holder Name :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>PT Carbay Service Pvt. Ltd.</span>
                                                </div>
                                            </div>

                                            <div className="payment-row row">
                                                <div className="col-md-6">
                                                    <span>Processing Fee :</span>
                                                </div>
                                                <div className="col-md-6">
                                                    <span>5,000</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    {/* Credit Card */}
                                    <div className="col-md-12">
                                    <div className="payment-section">
                                        <div className="section-header d-flex align-center space-bw p-sm-b">
                                        <h3>Payment Through Credit Card</h3>
                                        <i className="ic-content_copy"></i>
                                        
                                        </div>
                                        <div className="payment-row row">
                                            <div className="col-md-6">
                                                <span>Payment Link :</span>
                                                
                                            </div>
                                            <div className="col-md-6 payment-link">
                                                <a
                                                    href="https://oto.com/payment/insurance/comprehensive"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="payment-link"
                                                >
                                                    oto.com/payment/insurance/comprehensive
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    </div>


                                </div>
                            </div>

                            {/* Footer */}
                            <div className="payment-modal-footer p-lg-t">
                                <button className="btn-line m-sm-r">
                                    <i className="ic-share"></i>
                                </button>
                                <button className="btn-primary">Continue</button>
                            </div>
                        </>
                    )
                }


            </Modal>
        </div>
    );
}
